module.exports = __webpack_public_path__ + "static/media/fan.5df42ac7.svg";